import {RequestInfo} from "@khan/shared-core";

import {bestMatchLocale} from "./best-match-locale.ts";

// prettier-ignore
// sync-start:youtube-locales 1277517508 https://github.com/Khan/webapp/blob/master/services/content-library/rssfeeds/youtube_locale.go
export const YOUTUBE_LOCALES = [
    "aa", "ab", "af", "am", "ar", "arc", "as", "ase", "ay", "az", "ba", "be",
    "bg", "bh", "bi", "bn", "bo", "br", "bs", "ca", "cho", "chr", "co", "cs",
    "cy", "da", "de", "de-AT", "de-CH", "de-DE", "dz", "el", "en", "en-CA",
    "en-GB", "en-IE", "en-US", "eo", "es", "es-419", "es-ES", "es-MX", "es-US",
    "et", "eu", "fa", "fa-AF", "fa-IR", "ff", "fi", "fil", "fj", "fo", "fr",
    "fr-BE", "fr-CA", "fr-CH", "fr-FR", "fy", "ga", "gd", "gl", "gn", "gu",
    "ha", "hak", "hak-TW", "hi", "hi-Latn", "hr", "hu", "hy", "ia", "id", "ie",
    "ig", "ik", "is", "it", "iu", "iw", "ja", "jv", "ka", "kk", "kl", "km",
    "kn", "ko", "ks", "ku", "ky", "la", "lb", "ln", "lo", "lt", "lus", "lv",
    "mas", "mg", "mi", "mk", "ml", "mn", "mo", "mr", "ms", "mt", "my", "na",
    "nan", "nan-TW", "ne", "nl", "nl-BE", "nl-NL", "no", "nv", "oc", "om",
    "or", "pa", "pl", "ps", "pt", "pt-BR", "pt-PT", "qu", "rm", "rn", "ro",
    "ru", "ru-Latn", "rw", "sa", "scn", "sd", "sdp", "sg", "sh", "si", "sk",
    "sl", "sm", "sn", "so", "sq", "sr", "sr-Cyrl", "sr-Latn", "ss", "st", "su",
    "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tlh", "tn", "to",
    "tr", "ts", "tt", "tw", "ug", "uk", "ur", "uz", "vi", "vo", "wo", "xh",
    "yi", "yo", "yue", "yue-HK", "zh-CN", "zh-Hans", "zh-Hant", "zh-HK",
    "zh-SG", "zh-TW", "zu",
];
// sync-end:youtube-locales

/**
 * Map a ka_locale to a locale appropriate for Youtube API calls.
 *
 * @param {string} kaLocale
 * @return {string}
 */
export const getYoutubeLanguage = (): string => {
    // sync-start:ka-locale-to-youtube 1472682366 https://github.com/Khan/webapp/blob/master/services/content-library/rssfeeds/youtube_locale.go
    const specialCases = {
        he: "iw", // iw was replaced with he in 1989, but Youtube didn't get
        // the memo
        nb: "no",
        "zh-hans": "zh-CN",
        "zh-hant": "zh-TW",
    } as const;

    let locale = specialCases[RequestInfo.kaLocale] || RequestInfo.kaLocale;

    // Youtube uses upper case for the country
    locale = locale.replace(/-[^-]+$/, (match) => match.toUpperCase());

    return bestMatchLocale(YOUTUBE_LOCALES, locale);
    // sync-end:ka-locale-to-youtube
};
